import {
  FooterLinkProps,
  AssetLinkProps,
} from '@telus-alberta-health-web/shared-module';
import { useIntl } from '@leagueplatform/locales';
import GooglePlayBadge from 'assets/google-play-badge.svg';
import AppleStoreBadge from 'assets/apple-store-badge.svg';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';
import { EXTERNAL_LINKS } from 'common/links';

export const useAppFooterLinks = () => {
  const { formatMessage } = useIntl();

  const APP_DOWNLOAD_ASSET_LINKS: AssetLinkProps[] = [
    {
      src: AppleStoreBadge,
      url: 'https://apps.apple.com/ca/app/myhealth-records/id1545953662',
      alt: formatMessage({ id: 'STR_DOWNLOAD_APP_STORE' }),
    },
    {
      src: GooglePlayBadge,
      url: 'https://play.google.com/store/apps/details?id=ca.alberta.myhealthrecords&pcampaignid=web_share',
      alt: formatMessage({ id: 'STR_DOWNLOAD_GOOGLE_PLAY' }),
    },
  ];
  const footerLinks: FooterLinkProps[] = [
    {
      text: formatMessage({ id: 'STR_PRIVACY_POLICY' }),
      url: APP_MANAGED_ROUTES.PRIVACY_POLICY,
    },
    {
      text: formatMessage({ id: 'STR_TERMS_OF_SERVICE' }),
      url: EXTERNAL_LINKS.TERMS_OF_SERVICE,
    },
  ];
  return {
    footerLinks,
    appDownloadLinks: APP_DOWNLOAD_ASSET_LINKS,
  };
};
